import React,{Component} from 'react';
import $ from 'jquery';
import project from './data/project';
import projectImg from './images/projects/newportfolio.png'
const Project = (props) =>{
  $(document).ready(function () {
    var zindex = 10;
  
    $("div.card").click(function (e) {
      e.preventDefault();

      var isShowing = false;
  
      if ($(this).hasClass("show")) {
        isShowing = true;
      }
     
  
      if ($("div.cards").hasClass("showing")) {
        // a card is already in view
      
        $("div.card.show").removeClass("show");
        if (isShowing) {
          // this card was showing - reset the grid
          $("div.cards").removeClass("showing");
        } else {
          // this card isn't showing - get in with it
          $(this).css({ zIndex: zindex }).addClass("show");
        }
  
        zindex++;
      } else {
        // no cards in view
        $("div.cards").addClass("showing");
        $(this).css({ zIndex: zindex }).addClass("show");
  
        zindex++;
      }
    });
  });
   
  return( 


  
<div className="cards">
<div className="card">
  <div className="card__image-holder">
    <img className="card__image" src={`${props.imglink}`} alt="sample108" />
  </div>
  <div className="card-title">
    <a href="/" className="toggle-info btn">
      <span className="left"></span>
      <span className="right"></span>
    </a>
    <h2>
    {props.name}
    <small>{props.caption}</small>
    </h2>
  </div>
  <div className="card-flap flap1">
    <div className="card-description">
     {props.about}
    </div>
  </div>
</div>
 <div className="card-flap flap2">
 <div className="viewproject">
   <a  href={`${props.link}`} className="btn" target="_blank" rel="noopener noreferrer" >View Project</a>
 </div>
</div>
</div>
    )
}


export default class ProjectComponent extends Component {
    render() {
      return (   
        <div className="ProjectContainer" id="Projects">
      <h1>Some of <span className='white'> my<br/></span> recent  <span className='white'>  projects</span> </h1>
     <div className="ProjectShowcase">
      <Project name="Portfolio" about="The showcase of my skills and my various project. This Project is powered by HTML , CSS and JavaScript as core languages and React framework." imglink = {projectImg} link="https://rohaanmd.netlify.app/" />
      {
          project.map((project , index) => {

            return <Project name={project.name} about={project.about} imglink={project.imglink} link={project.link} key={index} />
          })

      }
      </div>
      <h3><span className='white'> <a href='https://github.com/rohaanmd/' target="_blank" rel="noopener noreferrer"> <i className="fab fa-github"></i> See more </a></span></h3>
  </div>
      )
    }
  }